/** Earned total: SMOD + quiz + manual + bonus task points (prefers API total_points). */
export function goalEarnedTotal(goal) {
  if (!goal) return 0;
  if (goal.total_points != null && goal.total_points !== undefined) {
    return Number(goal.total_points);
  }
  return (
    (Number(goal.points) || 0) +
    (Number(goal.quiz_points) || 0) +
    (Number(goal.manual_points) || 0) +
    (Number(goal.bonus_task_points) || 0)
  );
}

/** When API omits available_points, derive from earned total minus used voucher cost. */
export function goalAvailablePointsFallback(goal) {
  if (!goal) return 0;
  if (goal.available_points !== undefined && goal.available_points !== null) {
    return Number(goal.available_points);
  }
  return goalEarnedTotal(goal) - (Number(goal.used_points) || 0);
}
